import { render } from "./EventSetupView.vue?vue&type=template&id=7f8882c7&scoped=true"
import script from "./EventSetupView.vue?vue&type=script&lang=js"
export * from "./EventSetupView.vue?vue&type=script&lang=js"

import "./EventSetupView.vue?vue&type=style&index=0&id=7f8882c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8882c7"]])

export default __exports__